var data = {
	"body": "<path opacity=\".3\" d=\"M15 16c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z\" fill=\"currentColor\"/><circle cx=\"15\" cy=\"8\" opacity=\".3\" r=\"2\" fill=\"currentColor\"/><path d=\"M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2c2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
